export default {
  dockName: '机场名称',
  noWaylineTask: '暂无航线任务',
  battery: '电池',
  rightBattery: '右电池',
  temperature: '温度',
  temperatureNone: '无',
  capacity: '电量',
  dockLiveVideo: '机场直播视频',
  aiAlarm: 'AI告警',
  pictureInPicture: '画中画',
  alarmType: '告警类型',
  alarmImage: '告警图片',
  alarmTime: '告警时间',
  zoomFactor: '变焦{value}X',
  droneLiveVideo: '飞机直播视频',
  hideDetectionVideo: '隐藏检测视频',
  showDetectionVideo: '显示检测视频',
  imageTransmission: '图传',
  originalVideo: '原始视频',
  streamStarting: '直播流启动中...',
  detectionVideo: '检测视频',
  detectionVideoCompleted: '检测视频已完成',
  pullingStream: '正在拉流中',
  cameraWide: '广角',
  cameraZoom: '变焦',
  cameraIr: '红外',
  fullscreen: '全屏',
  exitFullscreen: '退出全屏',
  switchCameraMode: '切换相机模式',
  photoMode: '拍照模式',
  videoMode: '录像模式',
  smartLowLight: '智能低光',
  panoramaPhoto: '全景拍照',
  directedPhoto: '定向拍照',
  cameraMode: '相机模式',
  gimbalSwitch: '云台切换',
  gimbalRecenter: '回中',
  gimbalDown: '向下',
  gimbalYawRecenter: '偏航回中',
  gimbalPitchDown: '俯仰向下',
  takePhoto: '拍照',
  stopRecording: '停止录像',
  record: '录像',
  light: '灯光',
  turnOffLight: '关灯',
  turnOnLight: '开灯',
  flash: '爆闪',
  confirmTurnOffFlash: '是否关闭爆闪',
  confirmTurnOnFlash: '是否开启爆闪',
  textAnnouncement: '文本喊话',
  voiceAnnouncement: '语音喊话',
  voiceRecordAnnouncement: '录音喊话',
  infer: '推理',
  trace: '追踪',
  oneKeyTakeoff: '一键起飞',
  returnHome: '返航',
  suspendTask: '挂起任务',
  recoverTask: '恢复任务',
  stopPointFlight: '结束指点飞行',
  debugPanel: '调试面板',
  watermarkDock: '机场',
  watermarkDrone: '飞机',
  settingSuccess: '设置成功',
  selectResetMode: '请选择重置模式',
  droneNotConnected: '飞机未连接,不能操作',
  selectZoomLens: '请选择变焦镜头',
  enterZoomFactor: '请输入变焦倍数',
  droneNotConnectedZoom: '飞机未连接，不能变焦倍数',
  lensAlreadyType: '当前镜头已经是{type},请切换其他镜头',
  lensCannotSwitch: '镜头无法切换, 请选择要切换的镜头.',
  switchCameraSuccess: '成功切换实时摄像机.',
  inferStartSuccess: '开启推理成功',
  inferStopSuccess: '关闭推理成功',
  loading: '加载中',
  cancelTrace: '取消追踪',
  startTrace: '开始追踪',
  inferTimeout: '推理超时',
  waitTimeout: '等待超时',
  traceStopSuccess: '关闭追踪成功',
  traceStartSuccess: '开启追踪成功',
  detectionLabels: {
    pedestrian: '行人',
    person: '人',
    bicycle: '自行车',
    car: '汽车',
    van: '货车',
    truck: '卡车',
    tricycle: '三轮车',
    awningTricycle: '棚三轮车',
    bus: '公交车',
    motorcycle: '摩托车',
  },
  control: {
    dockInfo: '机场信息',
    droneInfo: '无人机信息',
    cabinTemperature: '舱内温度',
    windSpeed: '风速',
    rainfall: '降雨量',
    dockHumidity: '机场湿度',
    altitude: '海拔高度',
    workingVoltage: '工作电压',
    workingCurrent: '工作电流',
    availableStorage: '可用存储',
    airConditioner: '空调',
    on: '开启',
    off: '关闭',
    batteryLevel: '电池电量',
    elevation: '离地高度',
    returnDistance: '返航距离',
    horizontalSpeed: '水平速度',
    verticalSpeed: '垂直速度',
    signal: '信号',
    keyGuide: '键位查看',
    imageAlt: '图片',
    exitRemoteControl: '退出远程控制',
    enterRemoteControl: '进入远程控制',
    more: '更多',
    viewKeyGuideAria: '查看更多键位说明',
    securityTakeoffAltitude: '安全起飞高度(ALT)',
    flightWorkAltitude: '飞行作业高(ALT)',
    rthAltitudeLabel: '返航高(ALT)',
    lostLinkAction: '失联动作',
    targetAltitudeAgl: '目标点高度(AGL)',
    confirmTakeoff: '请确认是否一键起飞',
    rthAltitudeRequired: '返航高度不能为空',
    targetHeightRequired: '目标点高度不能为空',
    targetHeightBelowDock: '目标点高度不能小于机场高度,当前机场高度:{height}m',
    securityTakeoffHeightRequired: '安全起飞高度不能为空',
    commanderHeightRequired: '指点高度不能为空',
    suspendTaskSuccess: '挂起任务成功',
    resumeTaskSuccess: '恢复任务成功',
    noCurrentTask: '当前无任务',
    returnHomeSuccess: '返航成功',
    flightControlGranted: '成功获得飞行控制',
    flightControlExited: '退出飞行控制',
    rainfallLevel: {
      0: '无雨',
      1: '小雨',
      2: '中雨',
      3: '大雨',
    },
  },
}
